import { createAction } from "@reduxjs/toolkit";

/**
 * The signed-in user changed (sign-in, sign-out, or a different account).
 * The root reducer drops every slice holding that user's data back to its
 * initial state, which re-hydrates from the new user's cache (or nothing).
 */
export const userChanged = createAction("session/userChanged");
